import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-006a4d13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "item-header" }
const _hoisted_3 = { class: "item-sidebar" }
const _hoisted_4 = { class: "sidebar" }
const _hoisted_5 = { class: "info-container" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "field-container" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "field-container" }
const _hoisted_10 = { class: "validation-container" }
const _hoisted_11 = { class: "text-container" }
const _hoisted_12 = { class: "numpad-container" }
const _hoisted_13 = { class: "num-row" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "numbers" }, null, -1))
const _hoisted_16 = { class: "close-container" }
const _hoisted_17 = { class: "point-container" }
const _hoisted_18 = { class: "button-container" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "filter-container item-filter" }
const _hoisted_21 = { class: "place-container item-place" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Header = _resolveComponent("Header")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_BubbleList = _resolveComponent("BubbleList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Loader, {
      active: $setup.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (($setup.isLoading) = $event)),
      "can-cancel": false,
      "is-full-page": true,
      loader: "dots",
      width: 120,
      color: "#178aa1"
    }, null, 8, ["active"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Header, {
        title: _ctx.$t('generic.welcome').toUpperCase(),
        "bg-color": "#1789a1"
      }, {
        leftButton: _withCtx(() => [
          _createElementVNode("button", null, _toDisplayString(_ctx.$t('views.auth.leaveTheSession')), 1)
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('generic.selected')), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString($setup.showSelectedUser), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('generic.animationPlace')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString($setup.selectedPlaceName?.value), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('views.auth.codePin')), 1),
            _createElementVNode("h5", null, _toDisplayString(_ctx.$t('views.auth.enterYourCodeToStart')), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (num) => {
                return _createElementVNode("div", {
                  class: "numbers",
                  key: num,
                  onClick: ($event: any) => ($setup.numClick(num - 1))
                }, _toDisplayString(num - 1), 9, _hoisted_14)
              }), 64)),
              _hoisted_15,
              _createElementVNode("div", {
                class: "numbers",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.numClick(9)))
              }, "9"),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_font_awesome_icon, {
                  onClick: $setup.clearNum,
                  class: "fa-3x cursor-pointer",
                  icon: "fa-solid fa-delete-left"
                }, null, 8, ["onClick"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
              return _createElementVNode("div", {
                key: i,
                class: "points",
                style: _normalizeStyle({ backgroundColor: $setup.selectedNum.length >= i ? '#ffffff' : 'initial' })
              }, null, 4)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              disabled: $setup.checkForDisableConnection,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.onConnect && $setup.onConnect(...args)))
            }, _toDisplayString(_ctx.$t('generic.validate').toUpperCase()), 9, _hoisted_19)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_Header, {
        title: _ctx.$t('views.auth.whoAreYou'),
        "bg-color": "#A0D7E2",
        "font-size": "1.5rem",
        height: "10%"
      }, null, 8, ["title"]),
      _createVNode(_component_Filter, {
        locations: $setup.locations,
        groups: $setup.groups,
        "get-filter-data": $setup.filterData,
        "on-reset": $setup.resetFilter
      }, null, 8, ["locations", "groups", "get-filter-data", "on-reset"]),
      _createVNode(_component_BubbleList, {
        "data-list": $setup.userNames,
        "on-select": $setup.selectUser,
        "max-height": "60%"
      }, null, 8, ["data-list", "on-select"])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_Header, {
        title: _ctx.$t('views.auth.whereAreYou'),
        "bg-color": "#A0D7E2",
        "font-size": "1.5rem",
        height: "20%"
      }, null, 8, ["title"]),
      _createVNode(_component_BubbleList, {
        "data-list": $setup.animationPlacesNames,
        "on-select": $setup.selectPlace,
        "bubble-width": "10rem",
        "max-height": "85%"
      }, null, 8, ["data-list", "on-select"])
    ])
  ]))
}